import { FileText } from 'lucide-react'
import { getCategoryColorStyle } from '../../lib/categoryColors'

interface ChatMemoCardProps {
  snapshot: {
    syncId: string
    title: string
    preview: string
    tags: string[]
    color: string
  }
}

export function ChatMemoCard({ snapshot }: ChatMemoCardProps) {
  return (
    <div
      className="p-3 rounded-lg border border-base bg-surface-primary border-l-4"
      style={{
        borderLeftColor: snapshot.color
          ? getCategoryColorStyle(snapshot.color)
          : 'var(--cat-slate)',
      }}
    >
      <div className="flex items-start gap-2">
        <FileText className="w-4 h-4 text-caption flex-shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-heading truncate">{snapshot.title}</p>
          {snapshot.tags?.length > 0 && (
            <div className="flex gap-1 mt-0.5 flex-wrap">
              {snapshot.tags.slice(0, 3).map((tag) => (
                <span key={tag} className="text-meta text-primary-500">#{tag}</span>
              ))}
            </div>
          )}
          {snapshot.preview && (
            <p className="text-xs text-caption mt-1 line-clamp-2">{snapshot.preview}</p>
          )}
        </div>
      </div>
    </div>
  )
}
